export default "__VITE_ASSET__b9a523d6__"